module.exports = __webpack_public_path__ + "img/chart.44a8bc63.svg";